import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Sparkles, Map } from "lucide-react";
import { api } from "@/lib/api";

export function WhoSeesWhatCard() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/connections").then((r) => setC(r.data.connections.filter((x) => x.direction === "i_share" && x.status === "active"))).catch(() => setC([])); }, []);
  return (
    <section className="warm-card p-6" data-testid="who-sees-what-card">
      <div className="flex items-center gap-2 font-display font-bold text-stone-900"><Users className="w-4 h-4" /> Who sees what</div>
      {c === null ? <p className="text-sm text-stone-500 mt-2">Loading…</p> : c.length === 0 ? <p className="text-sm text-stone-500 mt-2">Nobody. Your garden, habits, wellbeing and journal are private until you connect with someone.</p>
        : <ul className="mt-2 text-sm text-stone-700 space-y-1">{c.map((x) => <li key={x.id} data-testid={`sees-${x.id}`}><span className="font-semibold">{x.other.handle}</span> · {x.tier_label}{x.coach_view ? " · coach view" : ""}{x.hidden_habits?.length ? ` · ${x.hidden_habits.length} habit${x.hidden_habits.length === 1 ? "" : "s"} hidden` : ""}</li>)}</ul>}
      <Link to="/people" className="inline-block mt-3 text-xs font-semibold text-rose-800 hover:underline" data-testid="manage-people-link">Manage on My people →</Link>
    </section>
  );
}

export function AiUsageCard() {
  const [u, setU] = useState(null);
  useEffect(() => { api.get("/me/ai-usage").then((r) => setU(r.data)).catch(() => {}); }, []);
  if (!u) return null;
  const pct = Math.min(100, Math.round((u.tokens / u.cap) * 100));
  return (
    <section className="warm-card p-6" data-testid="ai-usage-card">
      <div className="flex items-center gap-2 font-display font-bold text-stone-900"><Sparkles className="w-4 h-4" /> AI usage this month</div>
      <p className="text-sm text-stone-600 mt-1">{u.calls} request{u.calls === 1 ? "" : "s"} · about {u.tokens.toLocaleString()} of {u.cap.toLocaleString()} tokens{u.resting ? " · AI is resting until next month." : ""}</p>
      <div className="mt-2 h-2 rounded-full bg-stone-100 overflow-hidden"><div className="h-full bg-emerald-500" style={{ width: `${pct}%` }} /></div>
      <p className="text-[11px] text-stone-400 mt-2">Every request is de-identified first (names, numbers and name-like words removed). Nothing you write trains any model.</p>
    </section>
  );
}

export function DataMapCard() {
  const rows = [["Habits, check-ins, stages", "Yours. Shared only with people at the Habits tier or above, minus anything you hide."],
    ["Wellbeing check-ins, reflections", "Yours. Shared only at the Everything tier."],
    ["Journal", "Private. Shared one entry at a time, to one person, until you un-share."],
    ["Community posts, waters, cheers", "Visible to members in the same category under your handle."],
    ["AI requests", "De-identified text only; counted for your monthly budget; never used for training."],
    ["Audit log", "Who did what and when — kept for safety, never shown to other members."]];
  return (
    <section className="warm-card p-6" data-testid="data-map-card">
      <div className="flex items-center gap-2 font-display font-bold text-stone-900"><Map className="w-4 h-4" /> Your data, in plain words</div>
      <ul className="mt-2 text-sm text-stone-700 space-y-1.5">{rows.map(([k, v]) => <li key={k}><span className="font-semibold">{k}:</span> {v}</li>)}</ul>
    </section>
  );
}
